(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hustla-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hustla-localization')) {
  customElements.define('hustla-localization', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.manualKey = 'hustla-country-choice';
      this.sessionKey = 'hustla-country-checked';
      this.interacted = false;
      const signal = this.abort.signal;
      const remember = event => {
        const form = event.target.closest('form');
        if (!form || this.contains(form) || !form.querySelector('[name="country_code"]')) return;
        if (event.type === 'change' && event.target.name !== 'country_code') return;
        const country = form.querySelector('[name="country_code"]').value;
        this.interacted = true;
        try { localStorage.setItem(this.manualKey, country); } catch {}
        try { sessionStorage.setItem(this.manualKey, country); } catch {}
      };
      document.addEventListener('change', remember, {capture: true, signal});
      document.addEventListener('submit', remember, {capture: true, signal});
      const interacted = () => { this.interacted = true; };
      document.addEventListener('pointerdown', interacted, {once: true, passive: true, signal});
      document.addEventListener('keydown', interacted, {once: true, signal});
      this.localize();
    }
    hasManualChoice() {
      try { if (localStorage.getItem(this.manualKey)) return true; } catch {}
      try { if (sessionStorage.getItem(this.manualKey)) return true; } catch {}
      return false;
    }
    async localize() {
      if (this.dataset.enabled !== 'true' || this.dataset.designMode === 'true' || this.hasManualChoice()) return;
      const params = new URLSearchParams(location.search);
      const root = this.dataset.root || '/';
      if (root !== '/' || ['country', 'country_code', 'currency'].some(key => params.has(key))) {
        try { sessionStorage.setItem(this.sessionKey, '1'); } catch {}
        return;
      }
      try {
        if (sessionStorage.getItem(this.sessionKey)) return;
        sessionStorage.setItem(this.sessionKey, '1');
      } catch { return; }
      try {
        const url = new URL(root + 'browsing_context_suggestions.json', location.origin);
        url.searchParams.set('country[enabled]', 'true');
        url.searchParams.set('country[exclude]', this.dataset.country);
        const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(3500)});
        if (!response.ok) return;
        const data = await response.json();
        const countries = JSON.parse(this.dataset.countries || '[]');
        const country = data.suggestions?.map(item => item.parts?.country?.handle).find(code => countries.includes(code));
        if (!country || country === this.dataset.country || this.interacted || this.hasManualChoice() || window.HustlaTheme?.isCartBusy?.() || document.visibilityState !== 'visible' || !this.isConnected) return;
        const form = this.querySelector('form');
        form.querySelector('[name="country_code"]').value = country;
        const returnTo = form.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
        form.requestSubmit();
      } catch {}
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
